<template>
    <v-col cols="12" sm="12" lg="4" :class="setClass()">
        <v-card class="background-2 round-card">
            <v-card-text class="pa-0">
                <div class="pa-4">Timecard / Utente</div>
            </v-card-text>                            
            <div id="timecardsuser" class="px-2" ref="timecardsuser" style="height: 472px">
            </div>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-row dense>
                    <v-col cols="6" class="pa-4">
                    <div class="flex-column">
                        <span class="display-3 margin-auto info--text font-weight-thin">{{ totalTimecards }}</span>
                        <span class="margin-auto text-uppercase font-weight-light">Timecard</span>
                    </div>
                    </v-col>
                    <v-col cols="6" class="pa-4" style="border-left: 1px solid rgba(0, 0, 0, 0.12)">
                    <div class="flex-column">
                        <span class="display-3 margin-auto amber--text font-weight-thin">{{ totalTime | duration }}</span>
                        <span class="margin-auto text-uppercase font-weight-light">Ore</span>
                    </div>
                    </v-col>
                </v-row>
            </v-card-text>              
        </v-card>
    </v-col>
</template>

<script>

    import * as am4core from '@amcharts/amcharts4/core'
    import * as am4charts from '@amcharts/amcharts4/charts'
    import am4themes_animated from '@amcharts/amcharts4/themes/animated'
    import am4themes_material from '@amcharts/amcharts4/themes/material'

    am4core.useTheme(am4themes_material)
    am4core.useTheme(am4themes_animated)

    export default {
        name: 'timecards-user',
        props: {
            id: Number,
        },

        data() {
            return {
                chart: {},
                data: []
            }
        },

        computed: {
            totalTimecards() {
                return this.data.reduce((acc, data) => {
                    return acc + data.count
                }, 0)
            },

            totalTime() {
                return this.data.reduce((acc, data) => {
                    return acc + parseInt(data.duration_minutes)
                }, 0)
            }
        },

        methods: {
            initialize() {
                this.axios.get('timecards-user/' + this.id).then(response => {
                    if (this._isBeingDestroyed || this._isDestroyed) return
                    this.$store.commit('endProgress')

                    if(!_.isEmpty(this.chart)) {
                        this.chart.dispose();
                    }
                    this.chart = am4core.create(this.$refs.timecardsuser, am4charts.XYChart)
                    this.chart.data = response.data.data
                    this.data = response.data.data

                    // Create axes
                    let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
                    categoryAxis.dataFields.category = 'user'
                    categoryAxis.renderer.grid.template.location = 0
                    categoryAxis.renderer.minGridDistance = 30
                    categoryAxis.renderer.labels.template.horizontalCenter = 'middle'
                    categoryAxis.renderer.labels.template.fontSize = 12
                    categoryAxis.renderer.grid.template.disabled = true

                    //categoryAxis.renderer.minHeight = 110

                    let valueAxis = this.chart.yAxes.push(new am4charts.DurationAxis())
                    valueAxis.baseUnit = 'minute'
                    this.chart.durationFormatter.durationFormat  = "h 'Ore'"                  
                    valueAxis.renderer.minWidth = 50
                    valueAxis.renderer.grid.template.strokeDasharray = '4,4'
                    valueAxis.renderer.labels.template.fontSize = 12


                    // Create series
                    let series = this.chart.series.push(new am4charts.ColumnSeries())
                    series.sequencedInterpolation = true
                    series.dataFields.valueY = 'duration_minutes'
                    series.dataFields.categoryX = 'user'
                    series.columns.template.strokeWidth = 0

                    series.tooltip.pointerOrientation = 'vertical'

                    series.columns.template.maxWidth = 100
                    series.columns.template.column.cornerRadiusTopLeft = 15
                    series.columns.template.column.cornerRadiusTopRight = 15
                    series.columns.template.column.fillOpacity = 0.8
                    series.columns.template.tooltipText = "[font-size: 11px]{categoryX}:  [font-size: 11px bold]{valueY.formatDuration()}[/]";
                    series.columns.template.tooltipY = -10;


                    series.columns.template.adapter.add("fill", (fill, target) => {
                        return this.chart.colors.getIndex(target.dataItem.index);
                    });                    
                    // on hover, make corner radiuses bigger
                    let hoverState = series.columns.template.column.states.create('hover')
                    hoverState.properties.cornerRadiusTopLeft = 0
                    hoverState.properties.cornerRadiusTopRight = 0
                    hoverState.properties.fillOpacity = 1

                }, response => {
                    // error callback
                })                
            },

            setClass() {
                if(this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
                    return 'pa-0 pr-2 pl-0'
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    return 'pa-0'
                }
                if(this.$vuetify.breakpoint.xs) {
                    return 'pa-0 pr-0'
                }
            },
        },
        
        mounted() {
            this.$eventBusUtility.$on('updatedTaskboard', () => {
                this.initialize()
            })
        },

        created() {
            this.initialize()
        },

        beforeDestroy() {
            if (this.chart && !_.isEmpty(this.chart)) {
                this.chart.dispose()
            }
			this.$eventBusUtility.$off('updatedTaskboard')
		},   
    }
</script>